import Config from '../config'
import { defineStore } from 'pinia'

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        user: JSON.parse(localStorage.getItem('user'))
    }),
    actions: {
        login(bearerToken = null) {
            try {
                this.user = { 'token': bearerToken }
                localStorage.setItem('user', JSON.stringify(this.user))
            } catch (error) {
                console.error(error)
            }
        },
        logout() {
            this.user = null
            localStorage.removeItem('user')
            // The local env needs to setup the auth token based on the
            // dev token so don't redirect to JC
            if (Config.ENV !== 'local') {
                document.location = Config.SAML_SSO_URL
            }
        }
    }
})
